import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, Globe } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { CONTACT_EMAIL } from "@/lib/content";
import { http, errText } from "@/lib/api";

const field = "w-full bg-transparent border-b border-[#D9D1C2] focus:border-[#A8613C] outline-none py-3 text-[#2D2A26] placeholder:text-[#8A8377] transition-colors";

export const Contact = () => {
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/contact", f);
      toast.success("Message sent. Diana will reply soon.");
      setF({ name: "", email: "", message: "" });
    } catch (err) { toast.error(errText(err)); }
    setBusy(false);
  };
  return (
    <section id="contact" className="py-24 sm:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal><Overline>Contact</Overline></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl sm:text-5xl lg:text-6xl text-[#2D2A26]">Write to Shaya.</h2></Reveal>
          <Reveal delay={0.2} className="mt-10 space-y-5">
            <a data-testid="contact-email-link" href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-4 text-[#2D2A26] link-underline w-fit break-all"><Mail size={18} className="text-[#A8613C] shrink-0" />{CONTACT_EMAIL}</a>
            <p className="flex items-center gap-4 text-[#2D2A26]"><Globe size={18} className="text-[#A8613C]" />Sessions held online</p>
          </Reveal>
        </div>
        <Reveal className="lg:col-span-7">
          <form onSubmit={submit} className="space-y-6">
            <div className="grid sm:grid-cols-2 gap-6">
              <input data-testid="contact-form-name-input" required className={field} placeholder="Name" value={f.name} onChange={set("name")} />
              <input data-testid="contact-form-email-input" required type="email" className={field} placeholder="Email" value={f.email} onChange={set("email")} />
            </div>
            <textarea data-testid="contact-form-message-input" required rows={5} className={`${field} resize-none`} placeholder="Your message" value={f.message} onChange={set("message")} />
            <button data-testid="contact-form-submit-btn" disabled={busy} className="btn-pill bg-[#2D2A26] text-[#FBFBF8] hover:bg-[#A8613C] px-8 py-4 text-sm">
              {busy && <Loader2 size={16} className="animate-spin" />} Send message
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
